const logEvent = (data) => {
  const actionId = 'logEvent';
  const param = JSON.stringify(data);

  if (navigator.userAgent.indexOf('becon_ios') !== -1) {
    try {
      window.webkit.messageHandlers.logEvent.postMessage(param);
    } catch (e) {
      // Native 업데이트 버전 배포와 sync가 맞지 않는 경우 대비 (추후 삭제 예정)
      try {
        window.webkit.messageHandlers.logEventHandler.postMessage(param);
      } catch (e) {
        console.log('ios Error (' + e.toString() + ')');
      }
    }
  } else if (navigator.userAgent.indexOf('becon_android') !== -1) {
    try {
      window.Becon.requestAction('logEvent', actionId, param);
    } catch (e) {
      console.log('android Error (' + e.toString() + ')');
    }
  }
};

export default logEvent;
